export default (id) => {
  const idStr = String(id);
  if (idStr.length === 9) {
    return idStr.match(/.{1,3}/g).join(' ');
  }
  return id;
};
